import { TnAWorkedDaysDTO, TnAWorkedDaysSTO } from "../../models/tna";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class TnAWorkedDaysApiService extends BaseApiService<TnAWorkedDaysDTO, TnAWorkedDaysSTO> {
  constructor() {
    super({
      servicePath: "/TnAWorkedDays",
      loadItemsPath: "/GetTnAWorkedDays", // not supposed to read items here, they will be read as part of timesheet or dashboard data
      saveItemsPath: "/SaveTnAWorkedDays",
    });
  }
}

export const saveWorkedDays = async (item: TnAWorkedDaysSTO) => {
  const response = await new TnAWorkedDaysApiService().saveItems([item]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};
